import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_handld/layout/core'
import { HandlrListWrapper } from './handlr-list/HandlrList'

const handlrBreadcrumbs: Array<PageLink> = [
  {
    title: 'Handyman Management',
    path: '/backoffice/handyman-management',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const HandlrPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='handyman-management'
          element={
            <>
              <PageTitle breadcrumbs={handlrBreadcrumbs}>Handyman list</PageTitle>
              <HandlrListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/backoffice/handyman-management' />} />
    </Routes>
  )
}

export default HandlrPage
